import React from "react"
import {useTranslation} from "react-i18next"

import {useTimeLimits as useItems} from "../../contexts/TimeLimitContext"

import ItemList from '../../components/TimeLimits/List'
import PageList from '../common/List'

const PageTimeLimitsList: React.FC = () => {

    const { t } = useTranslation()

    const { fetchItems } = useItems()

    const
        itemType: string     = 'TimeLimits',
        itemTypeName: string = t('time-limits.title_list'),
        itemTypeUrl: string  = 'time-limits'

    return (
        <PageList
            ItemList={ItemList}
            itemType={itemType}
            itemTypeName={itemTypeName}
            itemTypeUrl={itemTypeUrl}
            showAddButton={true}
            fetchItems={fetchItems}
            useItems={useItems}
        />
    )
}

export default PageTimeLimitsList